import { AsYouType, getExampleNumber } from 'libphonenumber-js';
import examples from 'libphonenumber-js/examples.mobile.json';

import { CountryCode } from 'stores/local/shared/form/FieldPhoneStore';

// Смещение между ASCII-кодами букв и Unicode Regional Indicator Symbols (для флагов)
const REGIONAL_INDICATOR_OFFSET = 127397;

export const countryCodeToFlag = (countryCode: string): string =>
  String.fromCodePoint(
    ...countryCode
      .toUpperCase()
      .split('')
      .map((c) => REGIONAL_INDICATOR_OFFSET + c.charCodeAt(0)),
  );

export const getPlaceholder = (country: CountryCode) => {
  const example = getExampleNumber(country.code, examples);

  if (!example) {
    return '';
  }

  const nationalNumber = example.nationalNumber;

  const fmt = new AsYouType(country.code);
  const formatted = fmt.input(nationalNumber);

  return formatted || example.formatNational();
};
